import React, { useEffect, useRef, useState } from "react";
import styles from "../assets/scss/pages.module.scss";
import Title from "components/title/Title";
import PaintersDescriptionSection from "sections/paintersPage/paintersDescriptionSection/PaintersDescriptionSection";
import ChevronIcon from "components/svgs/ChevronIcon";
import { useClickOutside } from "hooks/useClickOutside";
import CloseIcon from "components/svgs/CloseIcon";
import FilterIcon from "components/svgs/FilterIcon";
import ArtistCard from "components/cards/artistCard/ArtistCard";

const PaintersPage = () => {
  const catalogDropdownRef = useRef(null);
  const [showCatalogDropdown, setShowCatalogDropdown] = useState(false);

  useClickOutside(catalogDropdownRef, () => {
    setShowCatalogDropdown(false);
  });

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, []);

  return (
    <div className={styles.paintersPageContainer}>
      <div className="container">
        <Title text={"Painters"} bottomStrokeWidth={"60%"} />
        <PaintersDescriptionSection />
        <div className={styles.catalogWrapper}>
          <div className={styles.artistsFollow}>
            <span>Artists</span>
            <span className={styles.divider}>|</span>
            <span>Follow</span>
          </div>
          <div className={styles.catalogContainer}>
            <div
              className={`${styles.label} ${
                showCatalogDropdown ? styles.open : ""
              }`}
              onClick={() => setShowCatalogDropdown(!showCatalogDropdown)}
            >
              <span>Alphabetical Catalog of Artists </span>
              <ChevronIcon />
            </div>
            {showCatalogDropdown ? (
              <div className={styles.dropdown} ref={catalogDropdownRef}>
                <div
                  className={styles.closeDropdown}
                  onClick={() => setShowCatalogDropdown(false)}
                >
                  <CloseIcon />
                </div>
                <div
                  className={styles.paintersListContainer}
                  style={{
                    maxHeight: `300px`,
                  }}
                >
                  <div className={styles.paintersListSmall}>
                    {Array.from(Array(100), (_, index) => (
                      <div className={styles.painter} key={index}>
                        Name Lastname
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            ) : null}
          </div>
        </div>
        <div className={styles.allFiltersContainer}>
          <div className={styles.filtersBtn}>
            All Filters <FilterIcon />
          </div>
        </div>
        <div className={styles.paintersListWrapper}>
          <div className={styles.paintersTitle}>Painters of Artsakh</div>
          <div className={styles.paintersList}>
            {Array.from(Array(16), (_, index) => (
              <ArtistCard type={"painter"} key={index} />
            ))}
          </div>
        </div>
        <div className={styles.loadMore}>
          <button>Load More</button>
        </div>
      </div>
    </div>
  );
};

export default PaintersPage;
